<template>
  <div class="feedback-page">
    <div class="page-header">
      <button class="back-btn" @click="$router.back()">‹ 返回</button>
      <div class="page-title">意见反馈</div>
    </div>

    <div class="feedback-form">
      <div class="form-group">
        <label class="form-label">反馈内容</label>
        <textarea v-model="content" class="form-textarea" placeholder="请描述您遇到的问题或建议（必填）" rows="6"></textarea>
      </div>

      <div class="form-group">
        <label class="form-label">联系电话（选填）</label>
        <input v-model="contactPhone" type="tel" class="form-input" placeholder="方便我们回复您" />
      </div>

      <button class="submit-btn" :disabled="!content.trim() || loading" @click="handleSubmit">
        {{ loading ? '提交中...' : '提交反馈' }}
      </button>
    </div>
  </div>
</template>

<script>
import { submitFeedback } from '@/api/feedback'

export default {
  name: 'UserFeedback',
  data() {
    return {
      content: '',
      contactPhone: '',
      loading: false
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.content.trim()) { this.$alert('请输入反馈内容'); return }
      this.loading = true
      try {
        await submitFeedback({
          type: 1,
          category: 'other',
          content: this.content.trim(),
          contactPhone: this.contactPhone || undefined
        })
        await this.$alert('感谢您的反馈，我们会尽快处理')
        this.$router.back()
      } catch (e) {
        this.$alert(e.message || '提交失败，请重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.feedback-page {
  width: 100%;
  min-height: 100vh;
  background: #f9fafb;
}

.page-header {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 20;
}

.back-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #ff720d;
  cursor: pointer;
  margin-right: 12px;
  padding: 0;
}

.page-title { font-size: 16px; font-weight: 600; color: #111827; }

.feedback-form {
  background: #fff;
  margin: 12px;
  border-radius: 12px;
  padding: 16px;
}

.form-group { margin-bottom: 16px; }

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.form-input, .form-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: #fff;
  box-sizing: border-box;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: #ff720d;
    box-shadow: 0 0 0 3px rgba(255, 114, 13, 0.12);
  }
  &::placeholder { color: #9ca3af; }
}

.form-textarea { resize: vertical; }

.submit-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(90deg, #ffa43a 0%, #ff720d 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active:not(:disabled) { opacity: 0.85; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}
</style>
